import { render, staticRenderFns } from "./DeleteRegionCatalogueDialog.vue?vue&type=template&id=4112d37d&"
import script from "./DeleteRegionCatalogueDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteRegionCatalogueDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports